import { gsap } from 'gsap';
function Animate(
  sprite,
  { duration = 0.5, speed = 1, ease = 'Cubic.easeIn', canvasHeight, canvasWidth, index, totalLines, istemplate }
) {
  var spriteWidht = sprite.width;
  var x = sprite.x;
  sprite.width = 0.05 * sprite.width;
  //sprite.x = canvasWidth / 2;
  sprite.x = x + spriteWidht / 2 - sprite.width;
  let delay = 0;
  if (istemplate && index && index > 0) {
    delay = index * (duration * speed);
  }
  var animation = gsap.to(sprite, {
    pixi: { x: x, width: spriteWidht },
    duration: speed,
    ease: 'slow(0.7, 0.7, false)',
    paused: true,
    delay: delay,
  });
  return animation;
}
export default { Animate };
